import axios from "axios";
import { getLocalStorage } from "components/Helper/Helper";
import { Config } from "../../Config.js";
import { errorToastMessage } from "utils/errorToast";
import {
  DEFAULT_ENTITY,
  ENTITY_LABEL,
  IS_CHECKED_2A2B,
  LOADER_STATUS,
  PROFILE_DATA,
  SET_ENTITY_LIST,
  STORE_GSTIN_GSTR2A2BNEW,
  STORE_PERIOD,
  STORE_PERIOD_SINGLE,
} from "./constants";
export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}

export function setDefaultEntity(payload) {
  return {
    type: DEFAULT_ENTITY,
    data: payload,
  };
}
export function profileInfo(payload) {
  return {
    type: PROFILE_DATA,
    profileData: payload,
  };
}
export function setEntityList(data) {
  return {
    type: SET_ENTITY_LIST,
    payload: data,
  };
}
export function storeSelectedGstinGSTR2A2BNEW(payload) {
  return {
    type: STORE_GSTIN_GSTR2A2BNEW,
    selectedGstin: payload,
  };
}
export function setPeriodStore(startDate, endDate) {
  return {
    type: STORE_PERIOD,
    date: { startDate, endDate },
  };
}
export function setPeriodStoreSingle(period) {
  return {
    type: STORE_PERIOD_SINGLE,
    date: period,
  };
}
export function setIsChecked(isChecked) {
  return {
    type: IS_CHECKED_2A2B,
    payload: isChecked,
  };
}

export function setEntityLabel(label) {
  return {
    type: ENTITY_LABEL,
    payload: label,
  };
}

export const getGstinByEntity = (value) => {
  console.log(value);
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      entity_id: value,
      user_id: getLocalStorage("user_id").user_id,
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getGstnListByEntityId`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            if (response.data?.data?.length > 0) {
              const sortedGstin = response.data.data.sort((a, b) =>
                a.gstin > b.gstin ? 1 : -1
              );
              dispatch(profileInfo(sortedGstin));
              resolve(sortedGstin);
            } else {
              dispatch(profileInfo([]));
              resolve([]);
            }
          }

          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export function getEntityList() {
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      user_id: getLocalStorage("user_id").user_id,
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getCompanyByUserId`,
        data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            let entityList = response.data.data.map((entity) => {
              return { value: entity.company_id, label: entity.name };
            });
            dispatch(setEntityList(entityList));
            resolve(true);
          } else {
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
}
